import Alert from "../Alert/Alert"
import Button from "../Button/Button"
import { ConfirmationAlertProps } from "./ConfirmationAlert.types"
import "./ConfirmationAlert.css"

const ConfirmationAlert = (props: ConfirmationAlertProps) => {
  const { 
    show,
    title,
    subtitle,
    onConfirmText,
    onCancelText,
    onConfirm,
    onCancel,
  } = props

  return (
    <Alert showAlert={show} onClose={onCancel}>
      <div className="confirm-delete-alert">
        <h2>{title}</h2>
        <p>{subtitle}</p>
        
        <div className="confirm-delete-buttons">
          <Button title={onCancelText} onClick={onCancel} type="outline" />
          <Button title={onConfirmText} onClick={onConfirm} type="full" />
        </div>
      </div>
    </Alert>
  )
}

ConfirmationAlert.defaultProps = {
  onConfirmText: "Okay",
  onCancelText: "Cancel"
}

export default ConfirmationAlert